var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.bgc),attrs:{"id":"gauge"}},[_c('GChart',{attrs:{"settings":({packages: ['gauge']}),"type":"Gauge","data":_vm.args.values,"options":_vm.chartOptions,"resizeDebounce":500},on:{"ready":_vm.onChartReady}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }